import type { ListenerEntry } from "@poscon/shared-frontend";
import type { RootDispatch, RootState } from "~redux/store";
import { startListening } from "~redux/listenerMiddleware";
import {
  dposConfigSelector,
  mapCenterSelector,
  viewDimensionSelector,
  viewIsFullscreenSelector,
  windgridStateSelector,
} from "~redux/slices/edstSlice";
import { headerRowHeight } from "~/utils/constants";
import type { GeoProjectionState } from "~/geoProjectionStore";
import { GeoProjectionStore } from "~/geoProjectionStore";

const listeners: ListenerEntry<RootState, RootDispatch>[] = [
  {
    predicate: (action, state, prevState) =>
      windgridStateSelector(state) !== windgridStateSelector(prevState) ||
      dposConfigSelector(state) !== dposConfigSelector(prevState) || 
      mapCenterSelector(state) !== mapCenterSelector(prevState),
    effect: (action, { getState }) => {
      const state = getState();
      const { scale, centerOverride } = windgridStateSelector(state);
      let center = mapCenterSelector(state);
      if (center[0] === 0 && center[1] === 0) {
        center = dposConfigSelector(state).windGridMapCenter;
      }
      windGridStore.setCenter(center);
      windGridStore.setMatrix(scale, centerOverride[0], centerOverride[1]);
    },
  },
  {
    predicate: (action, state, prevState) =>
      viewDimensionSelector(state, "WIND") !== viewDimensionSelector(prevState, "WIND") ||
      viewIsFullscreenSelector(state, "WIND") !== viewIsFullscreenSelector(prevState, "WIND"),
    effect: (action, { getState }) => {
      const state = getState();
      const isFullscreen = viewIsFullscreenSelector(state, "WIND");
      windGridStore.isFullscreen = isFullscreen;
      if (isFullscreen) {
        windGridStore.setDimensions({
          width: window.innerWidth - 3,
          height: window.innerHeight - headerRowHeight - 6,
        });
      } else {
        windGridStore.setDimensions(viewDimensionSelector(state, "WIND"));
      }
    },
  },
];

listeners.forEach((listener) => startListening(listener));

export type WindGridState = GeoProjectionState;

export const windGridStore = new GeoProjectionStore((dimensions) => [
  dimensions.width / 2,
  dimensions.height / 2,
]);
